module.exports = __webpack_public_path__ + "media/the-craftenstock-corporation.a1cc9493.mp3";